import React, { FC } from 'react';

interface DotsProps {
  activeItem: number;
}

export const Dots: FC<DotsProps> = ({ activeItem }) => {
  const steps = [1, 2, 3];

  return (
    <div className="product-tour-steps">
      {steps.map((step) => (
        <div key={step} className={`product-tour-step ${step === activeItem ? 'current-step' : ''}`} />
      ))}
    </div>
  );
};
